/**
 * CapacityNotice — what a customer sees when a product is full.
 *
 * Shared by all three signup surfaces (Deploy, Storefront, Creator) so hitting a cap
 * feels the same wherever it happens, and so the copy lives in one place.
 *
 * Styled as good news rather than an error: a red box reads as "you did something
 * wrong" or "this is broken", when the truth is that demand is high and we are pacing
 * onboarding on purpose. It is the brand lime, not the failure red.
 *
 * The message text comes from the server (customerCapGate.CAPACITY_MESSAGE) so the
 * wording cannot drift between the three products or between client and server.
 */

/**
 * @param {object}  props
 * @param {string}  props.message       Server-supplied copy. Never hardcode it here, or the
 *                                      three surfaces drift apart.
 * @param {string} [props.contactEmail] Support address; omitted rather than faked when unset.
 */
export default function CapacityNotice({ message, contactEmail }) {
  return (
    <div
      role="status"
      className="bg-lime-950/20 border border-lime-800/40 rounded-xl px-5 py-4 mb-6"
    >
      <div className="flex items-start gap-3">
        <span aria-hidden="true" className="text-lime-500 text-lg leading-none mt-0.5">
          ✦
        </span>
        <div>
          <p className="text-lime-300 text-sm font-medium mb-1">
            We are onboarding gradually right now
          </p>
          <p className="text-silver-medium text-sm leading-relaxed">{message}</p>
          <p className="text-silver-dark text-xs mt-3 leading-relaxed">
            Slots open regularly as we grow the fleet — please check back in a few days.
            {contactEmail && (
              <>
                {" "}
                If you need one sooner, email{" "}
                <a href={`mailto:${contactEmail}`} className="text-lime-600 hover:text-lime-400">
                  {contactEmail}
                </a>{" "}
                and we will let you know the moment a slot frees up.
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
